import React from 'react'
import { CoachColumn } from '../../styles'
import { Coach } from './Coach'
import { ASGTeamIds, WLLASGTeamIds } from '../../../../../../Constant'

type CoachesProps = {
  team: ASGTeamIds | WLLASGTeamIds
}

export const Coaches: React.FC<React.PropsWithChildren<CoachesProps>> = ({  team }) => {
  return (
      <CoachColumn>
        <Coach team={team} />
      </CoachColumn>
  )
}
